export const queryKeys = {
  SYKMELDINGER: "sykmeldinger",
  OPPFOLGINGSPLANER: "oppfolgingsplaner",
  TILGANG: "tilgang",
  NARMESTELEDERE: "narmesteledere",
  DINESYKMELDTE: "dinesykmeldte",
  ACTIVE_TEST_SCENARIO: "active-test-scenario",
  KONTAKTINFO: "kontaktinfo",
};
